// Chaves das ações em voo (`pendingActions`) e dos debounces locais
// (`activeDebouncesRef`). Ficam num módulo só para que quem gera e quem compara a
// chave use exatamente o mesmo formato: a comparação por `includes` que existia no
// App.tsx casava por substring e derrubava eventos realtime de outros bilhetes
// (ex.: com `cancel-ticket-12` pendente, o evento do bilhete 2 era descartado).

export const ticketActionKey = (ticketId: number, action: string) => `ticket:${ticketId}:${action}`
export const journeyActionKey = (aggregatorId: string, action: string) => `journey:${aggregatorId}:${action}`
export const bulkActionKey = (action: string) => `bulk:${action}`

export const cancelJourneyDebounceKey = (aggregatorId: string) => `cancel-agg-${aggregatorId}`
export const cancelTicketDebounceKey = (ticketId: number) => `cancel-ticket-${ticketId}`

// Igualdade exata (com o separador `:`) — nunca `includes`, que confunde 2 com 12.
export function debounceKeyTargetsTicket(key: string, ticketId: number): boolean {
  return key === cancelTicketDebounceKey(ticketId)
    || key.startsWith(`ticket:${ticketId}:`)
}

export function debounceKeyTargetsJourney(key: string, aggregatorId: string): boolean {
  return key === cancelJourneyDebounceKey(aggregatorId)
    || key.startsWith(`journey:${aggregatorId}:`)
}

export function hasPendingTicketDebounce(keys: Iterable<string>, ticketId: number): boolean {
  for (const key of keys) {
    if (debounceKeyTargetsTicket(key, ticketId)) { return true }
  }
  return false
}

export function hasPendingJourneyDebounce(keys: Iterable<string>, aggregatorId: string): boolean {
  for (const key of keys) {
    if (debounceKeyTargetsJourney(key, aggregatorId)) { return true }
  }
  return false
}
